import { render, staticRenderFns } from "./bankModalArchive.vue?vue&type=template&id=c793c318&scoped=true"
import script from "./bankModalArchive.vue?vue&type=script&lang=js"
export * from "./bankModalArchive.vue?vue&type=script&lang=js"
import style0 from "./bankModalArchive.vue?vue&type=style&index=0&id=c793c318&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c793c318",
  null
  
)

export default component.exports